<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="col-auto">
                <select class="form-control form-control-sm"
                        [(ngModel)]="selectedYear"
                        (ngModelChange)="changeYear($event)">
                    <option *ngFor="let item of listYear;" [ngValue]="item">{{item}} 년</option>
                </select>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                        [(ngModel)]="selectedMonth"
                        (ngModelChange)="changeMonth($event)">
                    <option *ngFor="let item of listMonth;" [ngValue]="item">{{item}} 월</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                   [(ngModel)]="searchValue"
                   (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                        (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="col"></div>
    <div class="col-auto"
        [hidden]="listType === DtgListType.modal">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clickOpenModalUserCarRunInfo(DtgActionType.create,null)">
            <i class="mdi mdi-plus"></i>
            <span class="ml-1">
                배차정보추가
            </span>
        </button>
    </div>
    <div class="col-auto"
         [hidden]="listType === DtgListType.modal">
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="clickOpenModalRegistUserCarRunInfo(DtgActionType.create,null)">
            <i class="mdi mdi-plus"></i>
            <span class="ml-1">
                배차정보 일괄등록
            </span>
        </button>
    </div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
                (click)="exportExcel()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <th>
                <input type="checkbox" class="form-control-sm"
                       name="selectAll"
                       [checked]="isSelectAllUserCarRun()"
                       (change)="changeUserCarRunSelectAll($event)"/>
            </th>
            <th>
                차량명
            </th>
            <th>
                운전자
            </th>
            <th>
                시작운행일
            </th>
            <th>
                시작운행시간
            </th>
            <th>
                종료운행일
            </th>
            <th>
                종료운행시간
            </th>
            <th>
                노선번호
            </th>
            <th>
                기점
            </th>
            <th>
                종점
            </th>
            <!--<th [hidden]="listType === DtgListType.modal">-->
            <th>
                편집
            </th>
        </thead>
        <tbody class="">
        <tr *ngFor="let item of listUserCarRun;index as idx;">
            <td>
                <input type="checkbox" class="form-control-sm"
                       name="userCarRunId"
                       [(ngModel)]="item.selected"
                       value="{{item.userCarRunId}}" />
            </td>
            <td>
                <span [hidden]="!item.dtgCarNo">{{item.dtgCarNo}}</span>
                <span [hidden]="item.dtgCarNo" class="text-warning">
                    미설정
                </span>
            </td>
            <td>
                <span [hidden]="!item.userNm">{{item.userNm}}</span>
                <span [hidden]="item.userNm" class="text-warning">
                    미설정
                </span>
            </td>
            <!--시작운행일-->
            <td>
                <span [hidden]="!item.dtgRegDtFromDate">{{item.dtgRegDtFromDate}}</span>
                <span [hidden]="item.dtgRegDtFromDate" class="text-warning">
                    미설정
                </span>
            </td>
            <!--시작운행시간-->
            <td>
                <span [hidden]="!item.dtgRegDtFromTime">{{item.dtgRegDtFromTime}}</span>
                <span [hidden]="item.dtgRegDtFromTime" class="text-warning">
                    미설정
                </span>
            </td>
            <!--종료운행일-->
            <td>
                <span [hidden]="!item.dtgRegDtToDate">{{item.dtgRegDtToDate}}</span>
                <span [hidden]="item.dtgRegDtToDate" class="text-warning">
                    미설정
                </span>
            </td>
            <!--종료운행시간-->
            <td>
                <span [hidden]="!item.dtgRegDtToTime">{{item.dtgRegDtToTime}}</span>
                <span [hidden]="item.dtgRegDtToTime" class="text-warning">
                    미설정
                </span>
            </td>
            <!--
            <td>
                <span [hidden]="listType === DtgListType.modal">{{item.dtgUnitId}}</span>
                <button type="button" class="btn btn-sm btn-link px-0"
                        [hidden]="listType === DtgListType.list"
                        (click)="clickSchedule(item)">
                    <span class="">{{item.dtgUnitId}}</span>
                </button>
            </td>
            -->
            <td>
                <span [hidden]="!item.drivePathNm">{{item.drivePathNm}}</span>
                <span [hidden]="item.drivePathNm" class="text-warning">
                    미설정
                </span>
            </td>
            <td>
                <span [hidden]="!item.drivePathFromNm">{{item.drivePathFromNm}}</span>
                <span [hidden]="item.drivePathFromNm" class="text-warning">
                    미설정
                </span>
            </td>
            <td>
                <span [hidden]="!item.drivePathToNm">{{item.drivePathToNm}}</span>
                <span [hidden]="item.drivePathToNm" class="text-warning">
                    미설정
                </span>
            </td>
            <td [hidden]="listType === DtgListType.modal">
                <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalUserCarRunInfo(DtgActionType.update,item)">
                    <i class="mdi mdi-pen"></i>
                    <span class="ml-1">수정</span>
                </button>
            </td>
        </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)">
    </list-paging>
</div>

<div class="row mt-3">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <div class="col-auto">
                <button type="button" class="btn btn-blockm btn-outline-danger"
                        (click)="clickDeleteUserCarRun()">
                    <i class="fa fa-trash"></i>
                    <span class="ml-1">
                        일정삭제
                    </span>
                </button>
            </div>

            <div class="col-auto"
                 [hidden]="listType === DtgListType.modal">
                <button type="button" class="btn btn-blockm btn-outline-danger"
                        (click)="clickOpenModalDeleteUserCarRun(DtgActionType.delete)">
                    <i class="mdi mdi-plus"></i>
                    <span class="ml-1">
                        일괄삭제
                    </span>
                </button>
            </div>
        </div>

    </div>
</div>
